// extracted by mini-css-extract-plugin
module.exports = {"container":"qb","overlay":"rb","headingSection":"sb","close":"tb","copy":"ub","m-heart-activate":"vb","bottomSection":"wb","disabled":"xb","m-heart-pulse":"yb"};